<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" class="text-center">
        <v-card v-if="loading" class="pa-5" elevation="3">
          <v-card-text>
            <v-progress-circular
              indeterminate
              color="primary"
              size="64"
              class="mb-4"
            ></v-progress-circular>
            <h3 class="text-h6 font-weight-bold">Memproses Login SSO...</h3>
            <p class="caption grey--text">
              Mohon tunggu sebentar, kami sedang menyiapkan sesi Anda.
            </p>
          </v-card-text>
        </v-card>

        <v-alert v-else type="error" outlined>
          <div class="d-flex flex-column">
            <span class="font-weight-bold">Gagal Login</span>
            <span class="mt-1">
              Tidak dapat memvalidasi sesi SSO. Kode login tidak valid atau kedaluwarsa.
            </span>
            <v-btn color="error" text class="mt-3" @click="retryLogin">
              Coba Lagi
            </v-btn>
          </div>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// In-memory guard: survives double-mount within the same page load,
// but never leaks across refreshes (unlike a sessionStorage flag).
let exchangeInFlight = false;

export default {
  name: "Callback",
  data() {
    return {
      loading: true,
      LAST_CODE_KEY: "sso_last_code",
    };
  },
  mounted() {
    if (exchangeInFlight) {
      console.warn("Already processing SSO callback - skipping");
      return;
    }

    const code = this.$route.query.code;

    console.log("SSO code present:", !!code);

    if (!code) {
      this.handleError();
      return;
    }

    // Same code already consumed (refresh / back navigation on this URL):
    // never re-send it - the ticket is single-use on the backend.
    if (sessionStorage.getItem(this.LAST_CODE_KEY) === code) {
      if (localStorage.getItem("access_token")) {
        console.warn("SSO code already exchanged - redirecting to dashboard");
        this.$router.replace({ name: "Dashboard" });
      } else {
        console.warn("SSO code already used without a session - showing error");
        this.handleError();
      }
      return;
    }

    this.handleSuccess(code);
  },
  methods: {
    async handleSuccess(code) {
      exchangeInFlight = true;
      sessionStorage.setItem(this.LAST_CODE_KEY, code);
      try {
        // Exchange the one-time ticket for the JWT (token never appears in the URL).
        await this.$store.dispatch("auth/ssoExchange", code);
      } catch (error) {
        console.error("Error processing SSO callback:", error);
        this.handleError();
      } finally {
        exchangeInFlight = false;
      }
    },
    handleError() {
      this.loading = false;

      console.error("SSO callback failed - no valid ticket code");
    },
    retryLogin() {
      sessionStorage.removeItem(this.LAST_CODE_KEY);
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");

      this.$router.replace("/login");
    },
  },
};
</script>
